module.exports = __webpack_public_path__ + "media/images/prizes/banner_bg-43d562c18ea539c9adf8ca2e77279da3.png";